/** @format */

import React from 'react'
import { _$, Step, Steps, Tag, Copy } from '@king-design/react'
import styled from 'styled-components'
import CodeDisplay from '../../../../components/CodeDisplay'
import { renderHTTPAddress } from './PythonAccess'

const OpenLLMetry: React.FC<{
  className?: string
  visible?: boolean
  appKey: string
  region: string
}> = ({ className, visible, appKey, region }) => {
  const installCommand = "pip install 'traceloop-sdk>=0.30.0'"
  const codeExample = `# 初始化 OpenLLMetry
from traceloop.sdk import Traceloop
from traceloop.sdk.instruments import Instruments

Traceloop.init(
    app_name=os.getenv("OTEL_SERVICE_NAME", "nanoagent"),
    api_endpoint="https://${region}.otlp.ksyun.com:4318",
    headers={"ksc-appkey": "********"},
    instruments={Instruments.LANGCHAIN},
)
# ── Run ───────────────────────────────────────────────────────────────
if __name__ == "__main__":
    # 设置session id
    set_conversation_id("session-100")`

  return (
    <Steps className={className} vertical type="simple">
      <Step title={_$('一、安装OpenLLMetry SDK')}>
        <>
          <p>{_$('通过pip安装OpenLLMetry SDK，要求python版本大于等于3.9')}</p>
          <CodeDisplay
            content={installCommand}
            language="shell"
            lineNumbers
            refreshTrigger={visible}
            height={40}
          />
        </>
      </Step>
      <Step title={_$('二、参考下面的代码示例，正确设置http header和otlp endpoint')}>
        <>
          <p>
            {_$('在exporter的')}
            <Tag>http headers</Tag>
            {_$('中正确设置')}
            <Tag>app-key</Tag>，{_$('格式如下')}： ksc-appkey：********
            <Copy text={appKey} />
          </p>
          {renderHTTPAddress(region)}
          <CodeDisplay
            content={codeExample}
            copyContent={appKey ? codeExample.replace(/\*{8}/g, appKey) : codeExample}
            language="python"
            height={305}
            lineNumbers
            refreshTrigger={visible}
          />
        </>
      </Step>
    </Steps>
  )
}

export default styled(OpenLLMetry)``
